/* ============
 * Mutations for the utilities module
 * ============
 *
 * The mutations that are available on the
 * utilities module.
 */

export default {
  setJWT (state, payload) {
    state.jwt = payload
  },
  setExp (state, payload) {
    state.exp = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/utilities/mutations.js